import React from 'react';
import { Button } from '../../design/primitives';
import { COLORS, SPACING, TYPOGRAPHY } from '../../design/tokens';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface MonthSelectorProps {
  month: Date;
  onChange: (month: Date) => void;
}

const MonthSelector: React.FC<MonthSelectorProps> = ({ month, onChange }) => {
  const prev = () => {
    const d = new Date(month);
    d.setMonth(d.getMonth() - 1);
    onChange(d);
  };

  const next = () => {
    const d = new Date(month);
    d.setMonth(d.getMonth() + 1);
    onChange(d);
  };

  const label = month.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: SPACING[8] }}>
      <Button variant="ghost" onClick={prev} style={{ padding: SPACING[4] }}>
        <ChevronLeftIcon style={{ width: '16px', height: '16px' }} />
      </Button>
      <span style={{
        fontFamily: TYPOGRAPHY.headings.fontFamily,
        fontSize: TYPOGRAPHY.headings.sizes.h3,
        fontWeight: TYPOGRAPHY.headings.weight,
        color: COLORS.text.primary,
        minWidth: '140px',
        textAlign: 'center',
      }}>
        {label}
      </span>
      <Button variant="ghost" onClick={next} style={{ padding: SPACING[4] }}>
        <ChevronRightIcon style={{ width: '16px', height: '16px' }} />
      </Button>
    </div>
  );
};

export default MonthSelector;
